import React  from "react";
import { useParams } from 'react-router-dom';
import Card from "components/card";
import { connect } from "react-redux";
import SettingForm from "./components/SettingForm";

const ViewEmployeeSetting = () => { 
	const { employeeId, settingId } = useParams();

	return (
	    <Card extra={"w-full h-full p-4"}>
			<SettingForm 
				recordId={settingId} 
				employeeId={employeeId}  
				mode="edit" 
			/>
		</Card>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewEmployeeSetting);